module.exports = __webpack_public_path__ + "static/media/error-512.d20c8368.png";